import { render, staticRenderFns } from "./invoiceConfig.vue?vue&type=template&id=2bc3e0ee&scoped=true"
import script from "./invoiceConfig.vue?vue&type=script&lang=js"
export * from "./invoiceConfig.vue?vue&type=script&lang=js"
import style0 from "./invoiceConfig.vue?vue&type=style&index=0&id=2bc3e0ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3e0ee",
  null
  
)

export default component.exports